import { 
  Box,
 } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { 
  GradientText,
  StyledButton
} from '../../utils/theme';
import { routingPath } from '../../utils/path';

const OrderComplete = () => {
  const navigate = useNavigate();

  const handleAddOrder = () => {
    navigate(routingPath.auth.orderList);
  }

  const handleOrderHistory = () => {
    navigate(routingPath.auth.orderHistory);
  };

  return (
    <Box sx={{ backgroundColor: '#f5f5f5', p: 4, borderRadius: 2, textAlign: 'center' }}>
      <GradientText variant="h5" sx={{ mb: 3, mt: 3 }}>
        注文が完了しました！
      </GradientText>
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
        <StyledButton onClick={handleOrderHistory}>注文を確認</StyledButton>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
        <StyledButton onClick={handleAddOrder}>注文を追加</StyledButton>
      </Box>
    </Box>
  );
};

export default OrderComplete;
